import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import SectorsList from './SectorsList/SectorsList';
import SectorCreate from './SectorCreate/SectorCreate';
import SectorEdit from './SectorEdit/SectorEdit';
import SectorDelete from './SectorDelete/SectorDelete';

const Sectors = ({ match }) => {
    return (
        <div className="Sectors">
            <ContainerWrapper container="sectors">
                <Route exact path={ match.path } component={SectorsList} />
                <Route exact path={ `${ match.url }/new` } component={SectorCreate} />
                <Route exact path={ `${ match.url }/edit/:sectorId` } component={SectorEdit} />
                <Route exact path={ `${ match.url }/delete/:sectorId` } component={SectorDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Sectors;

